import { type GetGlobalUserStatusDetailsQueryResult } from "common/types/mainHooks";
import { ActivationRedirectDestination } from "../AccountActivation/hooks";

type User = NonNullable<
  NonNullable<GetGlobalUserStatusDetailsQueryResult["data"]>["currentGlobalUser"]
>;

export const getRedirectUrl = (user: User, baseUrl: string, isSessionSpoofed: boolean) => {
  if (isSessionSpoofed) {
    // If the user is being spoofed, they shouldn't need to set up 2FA.
    return "";
  }

  if (!user.globalActivated) {
    // redirect user to 2FA setup if not completed
    return `${baseUrl}/join/setUpTwoFA`;
  }
  if (user.requiresTwoFaUpgrade) {
    // check if user requires 2FA upgrade after ensuring all unlinked accounts are linked.
    return `${baseUrl}/${ActivationRedirectDestination.UpgradeTwoFaSetup}`;
  } else if (user.hasUnlinkedLocalUsers) {
    // redirect user to link legacy accounts flow if any unlinked accounts exist
    return `${baseUrl}/${ActivationRedirectDestination.LegacyTwoFA}`;
  } else if (user.newLinkedArenaIds.length > 0) {
    // redirect user to new manager invitations if any exist
    return `${baseUrl}/${ActivationRedirectDestination.NewManagerInvitations}`;
  }
  // no redirect here - render children
  return "";
};
